import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { CommonService } from "src/app/Service/Common.service";
import { Module } from "src/app/Service/element-details.data.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { IProjectElementDetailsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { IDocSetModel, IDocSetRevisionDetailsInputModel, IDocSetStageDetail, IScheduleDefinitionModel, IStageElementDetails } from "src/app/ViewModel/ScheduleDefinitionModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";

@Component({
    selector: 'app-docset-revise',
    templateUrl: './docset-revise.component.html'
})
export class DocSetReviseComponent implements OnInit {
    @ViewChild('docsetrevisionform',{static: true}) dciElementDetailsForm!: DynamicFormComponent;
    isStageConfigLoaded: boolean = false;
    projectId!: number;
    groupId!: number;
    memberId!: number;
    projectCode!: string;
    docSetStageConfig: FieldConfig[] = [];
    docSet: IDocSetModel;
    schDef: IScheduleDefinitionModel;
    noOfDocs: number;

    public docsetForm: FormGroup = new FormGroup({
        reason: new FormControl('', [Validators.required])
    })
    
    constructor(private _projInfoService: ProjectInfoService, private _commonService: CommonService, public _dialogRef: MatDialogRef<DocSetReviseComponent>, @Inject(MAT_DIALOG_DATA) public _data: any,
        private _scheDefService: ScheduleDefinitionService, private _notificationService: NotificationService,private datepipe: DatePipe) {
        this.docSet = this._data.docSet;
        this.schDef = this._data.schDef;
        this.noOfDocs = this._data.noOfDocs;
    }
    ngOnInit() {     
        this.projectId = this._commonService.getProjectId();
        this.projectCode = this._commonService.getProjectCode();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.memberId = this._commonService.getLoggedInUserId();
        this.noOfDocs = this.noOfDocs - this.docSet.number_Of_Docs;
        if (this.noOfDocs <= 0) {
            this.noOfDocs = 0
        }
        this.loadDynamicForm();

    }

    loadDynamicForm() {
        this._projInfoService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Workflow, deDescription: 'Workflow Status' }).subscribe((res: IProjectElementDetailsOutput[]) => {
            this.docSetStageConfig = res.map(x => {
                let field: FieldConfig = {
                    type: 'eipdaterange', de_id: x.dedId,
                    name: x.dedShortDescription, label: x.dedDescription + " (" + x.dedShortDescription + ")", 
                    rangeControlNames: [x.dedShortDescription + 'StartDate', x.dedShortDescription + 'EndDate'], 
                    value: new BehaviorSubject([]),
                    startDate: null,
                    endDate: null,
                    Var: true
                }
                return field;
            })
            this.isStageConfigLoaded = true;
            this.getDocSetRevisionForm();
        })
    }

    getDocSetRevisionForm() {
        let dciRevisionConfig: FieldConfig[] = [];
        dciRevisionConfig.push(
            { type: "label", label: "Discipline", value: new BehaviorSubject(this.docSet.disc_Description) },
            { type: "label", label: "Structure/Package Name", value: new BehaviorSubject(this.docSet.structure_Description) },
            { type: "label", label: "Document Set", value: new BehaviorSubject(this.docSet.document_Set_Name) }
        );
        dciRevisionConfig = dciRevisionConfig.concat(this.docSetStageConfig);
        dciRevisionConfig.push({ type: "label", label: "No of Documents", value: new BehaviorSubject(this.docSet.number_Of_Docs) });
        if (this.noOfDocs > 0) {
            dciRevisionConfig.push({
                type: 'input',
                name: 'noOfDocsRequired',
                label: 'Enter DCI Count',
                validations: [
                    {
                        name: "pattern",
                        validator: Validators.pattern("^[0-9]*$"),
                        message: "Enter only numbers"
                    },
                    {
                        name: "min",
                        validator: Validators.min(1),
                        message: "Minimum No Of Docs Required:1"
                    },
                    {
                        name: "max",
                        validator: Validators.max(this.noOfDocs),
                        message: "Maximum No Of Docs Required:" + (this.noOfDocs)
                    }
                ]
            });
        }
        this.docSetStageConfig.forEach(x => {
            let stageDetail: any = this.getStageDetail(this._data.schDef, x);
            let docSetStageDetail: any;
            docSetStageDetail = this.getDocSetStageDetail(this._data.docSet, x);
            if(stageDetail){
            let field: any = dciRevisionConfig.find(x => x.de_id == stageDetail.stage_Id);
            //Range from schedule defintion
            field.minDate = stageDetail.start_Date;
            field.maxDate = stageDetail.end_Date;
            //Selected value from current edited document set
            field.value.next([docSetStageDetail.start_Date, docSetStageDetail.end_Date]);
            }
        })
        this.dciElementDetailsForm.fields = [];
        this.dciElementDetailsForm.fields = dciRevisionConfig;
        this.dciElementDetailsForm.createControl();
    }

    /**
 * Gets the particular stage element details
 * @param data Schedule Defintion Model Data
 * @param stage Stage Details
 * @returns Stage Element Details
 */
    getStageDetail(data: IScheduleDefinitionModel, stage: FieldConfig): IStageElementDetails|undefined {
        return data.stageElementDetails.find(x => x.stage_Id == stage.de_id);
    }

    /**
* Gets the particular stage element details
* @param data Document Set Model Data
* @param stage Stage Details
* @returns Stage Element Details
*/
    getDocSetStageDetail(data: IDocSetModel, stage: FieldConfig): IStageElementDetails|undefined {
        return data.stageDocumentSetDetails.find(x => x.stage_Id == stage.de_id);
    }

    saveDocsetRevise() {
        if(this.docsetForm.invalid){
            this._notificationService.showToast("Mandatory fields are missing", "Warning");
            this.docsetForm.get('reason')?.markAsTouched();           
            return;
        }
        this._scheDefService.insertDocsetRevise({ project_Id: this.projectId, group_Id: this.groupId, doc_Set_Id: this.docSet.doc_Set_Id, member_Id: this.memberId,reason : this.docsetForm.get('reason')?.value })
            .subscribe((x: StandardOutputModel) => {
                if (x.successCode == 200) {
                    let form: FormGroup = this.dciElementDetailsForm.value;
                    let stageDetails: IDocSetStageDetail[] = this.docSetStageConfig.map(x => {
                        let stageDetail: IDocSetStageDetail = {
                            stage_Id: x.de_id, start_Date:x.rangeControlNames? this.datepipe.transform(form.get(x.rangeControlNames[0])?.value, 'dd-MMM-yyyy'):null,
                            end_Date: x.rangeControlNames ? this.datepipe.transform(form.get(x.rangeControlNames[1])?.value, 'dd-MMM-yyyy'):null
                        };
                        return stageDetail;
                    })
                    let noOfDocsRequired:number = Number(form.get('noOfDocsRequired')?.value);
                    if (noOfDocsRequired != 0 && noOfDocsRequired <= 0) {
                        noOfDocsRequired = this.docSet.number_Of_Docs
                    }
                    else{
                        noOfDocsRequired = Number(form.get('noOfDocsRequired')?.value) + this.docSet.number_Of_Docs
                    }
                    let updateDocSetRevise: IDocSetRevisionDetailsInputModel = {
                        project_Id: this.projectId, group_Id: this.groupId,
                        member_Id: this.memberId, doc_Set_Id: this.docSet.doc_Set_Id, doc_Count: noOfDocsRequired, docSetStageDetails: stageDetails
                    };
                    this._scheDefService.updateDCIScheduleRevisedDocDetails(updateDocSetRevise).subscribe((y: StandardOutputModel) => {
                      
                        if (y.successCode == 200) {
                            this._notificationService.showToast(y.successMessage, "Success");
                            this.closeDialog();
                        }
                        else {
                            this._notificationService.showToast(y.successMessage, "Error");
                        }
                    })
                }
                else {                  
                    this._notificationService.showToast(x.successMessage, "Error");
                }
            })
    }

    closeDialog() {
        this._dialogRef.close();
    }
}